import React, { type JSX } from 'react';
import SiteLogo, {
  type SiteLogoProps,
} from '@resources/js/components/SiteLogo/SiteLogo';

export default function EnhancedMarkdownSiteLogo(
  props: SiteLogoProps,
): JSX.Element {
  return <SiteLogo {...props} />;
}
